import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["classes", "children", "edsContext"];
import React from 'react';
import PropTypes from 'prop-types';
import { Collapse } from '@material-ui/core';
import { default as MuiTreeItem } from '@material-ui/lab/TreeItem';
import { ChevronDown, ChevronRight, ChevronLeft } from '@ellucian/ds-icons/lib';
import { boxShadowFocus, fontWeightBold, spacing10, spacing20, borderRadiusXSmall } from '../styles/tokens';
import { withStyles } from '../styles';
import { withEDSContext } from './../EDSContext/EDSContext';

var styles = function styles(theme) {
  return {
    // default mui has a background for ctaColor.base
    // doesn't work with our design, so I'm making them all transparent
    root: {
      width: 'fit-content',
      padding: spacing20,
      '&:focus > $content': {
        background: 'transparent',
        boxShadow: boxShadowFocus
      },
      '&:focus > $content $label': {
        background: 'transparent'
      },
      '&$selected > $content $label': {
        background: 'transparent'
      },
      '&$selected > $content:hover, &$selected > $content $label:hover, &$selected:focus > $content, &$selected:focus > $content $label': {
        background: theme.palette.grey[200]
      },
      '&$selected:active > $content, &$selected:active > $content $label': {
        background: theme.palette.grey[250]
      } // '&$disabled > $content': {
      //     color: theme.palette.disabled.background,
      //     fill: theme.palette.disabled.background,
      //     pointerEvents: 'none',
      //     boxShadow: 'unset',
      //     background: 'transparent',
      //     padding: 0
      // }

    },
    selected: {
      '& > $content > $label': {
        color: theme.palette.ctaColor.base,
        fill: theme.palette.ctaColor.base,
        fontWeight: fontWeightBold
      },
      '& > $content > $iconContainer > svg': {
        fill: theme.palette.ctaColor.base
      },
      '&:hover > $content > $label': {
        color: theme.palette.ctaColor.hover
      },
      '&:hover > $content > $iconContainer > svg': {
        color: theme.palette.ctaColor.hover,
        fill: theme.palette.ctaColor.hover
      },
      '&:active > $content > $label': {
        color: theme.palette.ctaColor.active
      },
      '&:active > $content > $iconContainer > svg': {
        color: theme.palette.ctaColor.active,
        fill: theme.palette.ctaColor.active
      }
    },
    expanded: {},
    group: {
      margin: '0 0 0 1.625rem',
      padding: 0
    },
    content: {
      color: theme.palette.grey[600],
      padding: "0 " + spacing10,
      borderRadius: borderRadiusXSmall,
      '&:hover': {
        color: theme.palette.ctaColor.hover,
        fill: theme.palette.ctaColor.hover,
        background: theme.palette.grey[200]
      } // '&$disabled': {
      //     color: theme.palette.action.disabled,
      //     fill: theme.palette.action.disabled
      // },

    },
    iconContainer: {
      width: 'unset'
    },
    label: {
      whiteSpace: 'nowrap',
      '&:hover': {
        background: 'transparent'
      }
    },
    collapseExpandIcons: {
      marginLeft: theme.spacing(1)
    } // disabled: {}

  };
};
/**
 * An item in TreeView
 */


var TreeItem = function TreeItem(props) {
  var classes = props.classes,
      children = props.children,
      edsContext = props.edsContext,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var classOverrides = {
    root: classes.root,
    expanded: classes.expanded,
    selected: classes.selected,
    group: classes.group,
    content: classes.content,
    iconContainer: classes.iconContainer,
    label: classes.label
  };
  return /*#__PURE__*/React.createElement(MuiTreeItem, _extends({
    classes: classOverrides
  }, rest, {
    expandIcon: edsContext.dir === 'rtl' ? /*#__PURE__*/React.createElement(ChevronLeft, {
      "data-testid": "chevron-left",
      className: classes.collapseExpandIcons
    }) : /*#__PURE__*/React.createElement(ChevronRight, {
      "data-testid": "chevron-right",
      className: classes.collapseExpandIcons
    }),
    collapseIcon: /*#__PURE__*/React.createElement(ChevronDown, {
      className: classes.collapseExpandIcons
    })
  }), children);
};

TreeItem.muiName = 'TreeItem';
TreeItem.propTypes = {
  /**
   * @ignore
   */
  edsContext: PropTypes.object,

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  collapseIcon: PropTypes.node,

  /**
   * @ignore
   * The icon displayed next to a end node.
   */
  endIcon: PropTypes.node,

  /**
   * @ignore
   * The icon used to expand the node.
   */
  expandIcon: PropTypes.node,

  /**
   * The icon to display next to the tree node's label.
   */
  icon: PropTypes.node,

  /**
   * The tree node label.
   */
  label: PropTypes.node,

  /**
   * The id of the node.
   */
  nodeId: PropTypes.string.isRequired,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * @ignore
   * `onClick` handler for the icon container. Call `event.preventDefault()` to prevent `onNodeToggle` from being called.
   */
  onIconClick: PropTypes.func,

  /**
   * @ignore
   * `onClick` handler for the label container. Call `event.preventDefault()` to prevent `onNodeToggle` from being called.
   */
  onLabelClick: PropTypes.func,

  /**
   * @ignore
   * The component used for the transition.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * @ignore
   * Props applied to the `Transition` element.
   */
  TransitionProps: PropTypes.object
};
TreeItem.defaultProps = {
  TransitionComponent: Collapse
};
export default withEDSContext(withStyles(styles)(TreeItem));